/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLinksFromProduct}  from "./../../themes/kent/utilities/dataFunctions";

interface IProps {
  product?: any;
  parentProduct?: any;
  year?:any;
}

interface IState {
  links?: any;
}
/**
 *
 * Callouts component
 * @extends {React.Component<IProps>}
 */
 class Links extends React.Component<IProps> {

   public state: IState;

   constructor(props: IProps) {
     super(props);
     this.state={links:null}
   }

  componentDidMount = async() =>{
    let product:any = this.props.product;
    if(this.props.parentProduct){
      product = this.props.parentProduct;
    }
    let links:any = await GetLinksFromProduct(product)
    console.log(links)
    this.setState({
      links:links
    })
  }


  public render(): JSX.Element {
    return(
      <div>
        {this.state.links && this.state.links.map((link:any) =>{
          return(
            <div style={{marginTop:15}}>
              <a target="_blank" href={link.attributes.link}>{link.attributes.title}</a>
            </div>
          )
        })}
      </div>
    )
  }
};

export default Links;
